import React from 'react';

export interface DownloadButtonProps {
    color?: 'default' | 'primary' | 'success' | 'info' | 'warning' | 'danger' | 'link';
    disabled?: boolean;
    href: string;
}

export const DownloadButton: React.FC<DownloadButtonProps> = (props) => {

    let color = props.color || 'default';
    let btnCss = 'btn btn-' + color;
    if (props.disabled) 
        btnCss += ' disabled';

    return (
        <a href={props.href} className={btnCss} target="_blank" rel="noopener noreferrer">{props.children}</a>
    );
}

(DownloadButton as any).displayName = 'DownloadButton';